import { useEffect, useState } from 'react';

const DEBOUNCE_MS = 300;

// Debounces a fast-changing value.
export const useDebounce = (value, delay = DEBOUNCE_MS) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
};
